// extracted by mini-css-extract-plugin
export default {"input":"q--z","button":"r--z","selected":"s--z","unavailable":"t--z","oos":"u--z","image":"v--z","paperCutDisabledOverlay":"w--z"};